import { OverlayView } from '@react-google-maps/api';
import PropTypes from 'prop-types';

const RotatedMarker = ({
  position,
  iconUrl,
  rotation = 0,
  size = 32,
  onClick,
  anchor,
}) => {
  // anchor = circle center in scaled px
  // SVG: cx=25,cy=21 in 50x50 viewBox → scaled to size → 50% and 42%
  const anchorX = anchor?.x ?? size * 0.5;
  const anchorY = anchor?.y ?? size * 0.42;

  // shifts overlay so anchorX/anchorY sits exactly on lat/lng pixel
  // this is zoom-independent — recalculated on every render
  const getPixelPositionOffset = () => ({
    x: -anchorX,
    y: -anchorY,
  });

  return (
    <OverlayView
      position={position}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
      getPixelPositionOffset={getPixelPositionOffset}
    >
      <button
        type="button"
        aria-label="vehicle marker"
        style={{
          background: 'none',
          border: 'none',
          padding: 0,
          margin: 0,
          width: size,
          height: size,
          cursor: 'pointer',
          outline: 'none',
          display: 'block',
          // rotate around circle center of SVG, not geometric center
          transform: `rotate(${rotation}deg)`,
          transformOrigin: `${anchorX}px ${anchorY}px`,
          transition: 'transform 0.3s linear',
        }}
        onClick={onClick}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick?.(e);
          }
        }}
      >
        <img
          src={iconUrl}
          alt="vehicle"
          style={{
            width: size,
            height: size,
            display: 'block',
            pointerEvents: 'none',
          }}
          draggable={false}
        />
      </button>
    </OverlayView>
  );
};

RotatedMarker.propTypes = {
  position: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  }).isRequired,
  iconUrl: PropTypes.string.isRequired,
  rotation: PropTypes.number,
  size: PropTypes.number,
  onClick: PropTypes.func,
  anchor: PropTypes.shape({ x: PropTypes.number, y: PropTypes.number }),
};

export default RotatedMarker;
